import { useState } from "react";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch("/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setStatus({ type: "success", message: "Mensagem enviada com sucesso! Entraremos em contato em breve." });
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus({ type: "error", message: result.message || "Erro ao enviar. Tente novamente." });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Erro de conexão. Verifique sua internet e tente novamente." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section section-bgc" id="contact-form">
      <div className="container">
        <div className="row">
          <header className="col-12">
            <div className="section-heading heading-center">
              <div className="section-subheading">Fale Conosco</div>
              <h2>Entre em Contato</h2>
              <p className="section-desc">
                Tem um projeto em mente? Envie sua mensagem e responderemos o mais breve possível.
              </p>
            </div>
          </header>

          <div className="col-12 d-flex justify-content-center">
            <form className="contact-form" onSubmit={handleSubmit}>
              {status.message && (
                <div className={`alert alert-${status.type}`}>
                  {status.message}
                </div>
              )}
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label htmlFor="name">Nome</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Seu nome completo"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label htmlFor="email">E-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="seu@email.com"
                      required
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="subject">Assunto</label>
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Assunto da sua mensagem"
                      required
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="message">Mensagem</label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      placeholder="Descreva seu projeto ou dúvida..."
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-12">
                  <div className="btn-group justify-content-center">
                    <button type="submit" className="btn btn-with-icon btn-w240 ripple" disabled={loading}>
                      <span>{loading ? "Enviando..." : "Enviar Mensagem"}</span>
                      <svg className="btn-icon-right" viewBox="0 0 13 9" width="13" height="9">
                        <use xlinkHref="/assets/img/sprite.svg#arrow-right"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
